import React, { useEffect, useRef, useState, } from "react";
import { MetaTags } from "react-meta-tags";
import { commonPageField, commonPageFieldSuccess, postSelect_Field_for_dropdown, postSelect_Field_for_dropdown_Success } from "../../../../store/actions";
import { useHistory } from "react-router-dom";
import { BreadcrumbShowCountlabel } from "../../../../store/Utilites/Breadcrumb/actions";
import { useDispatch, useSelector } from "react-redux";
import { Go_Button, PageLoadingSpinner, SaveButton } from "../../../../components/Common/CommonButton";
import {
    breadcrumbReturnFunc,
    date_ymd_func,
    loginCompanyID,
    metaTagLabel,
} from "../../../../components/Common/CommonFunction";
import * as pageId from "../../../../routes/allPageID"
import * as mode from "../../../../routes/PageMode"
import Select from "react-select";
import SaveButtonDraggable from "../../../../components/Common/saveButtonDraggable";
import { getPosRateList_Action, getPosRateListSuccess, PosRateSave_Action, PosRateSave_Success } from "../../../../store/SweetPOSStore/Administrator/SweetPOSRateMasterRedux/action";
import { customAlert } from "../../../../CustomAlert/ConfirmDialog";
import { url } from "../../../../routes";
import { Col, FormGroup, Input, Label } from "reactstrap";
import { C_DatePicker, C_Select, CInput, decimalRegx } from "../../../../CustomValidateForm";
import { alertMessages } from "../../../../components/Common/CommonErrorMsg/alertMsg";
import GlobalCustomTable from "../../../../GlobalCustomTable";
import { getPartyTypelist } from "../../../../store/Administrator/PartyTypeRedux/action";

const SweetPOSRateMaster = (props) => {

    const history = useHistory()
    const dispatch = useDispatch();
    const currentDate_ymd = date_ymd_func();

    const [pageMode] = useState(mode.defaultsave);
    const [userPageAccessState, setUserAccState] = useState(123);
    const [effectiveFrom, setEffectiveFrom] = useState(currentDate_ymd);
    const [rateTypeSelect, setRateTypeSelect] = useState([]);
    const [partyType_dropdown_Select, setPartyType_dropdown_Select] = useState("");
    const changedRatesRef = useRef({});
    const originalRatesRef = useRef({});
    const originalDefaultsRef = useRef({});
    //Access redux store Data /  'save_ModuleSuccess' action data
    const {
        saveBtnloading,
        postMsg,
        listBtnLoading,
        PosRateMasterListData,
        RateTypeList,
        PartyTypes,
        userAccess } = useSelector((state) => ({
            saveBtnloading: state.PosRateMasterReducer.saveBtnloading,
            postMsg: state.PosRateMasterReducer.postMsg,
            listBtnLoading: state.PosRateMasterReducer.listBtnLoading,
            PosRateMasterListData: state.PosRateMasterReducer.PosRateMasterListData,
            RateTypeList: state.PartyMasterBulkUpdateReducer.SelectField,
            userAccess: state.Login.RoleAccessUpdateData,
            PartyTypes: state.PartyTypeReducer.ListData,
        }));

    const location = { ...history.location }
    const hasShowloction = location.hasOwnProperty(mode.editValue)
    const hasShowModal = props.hasOwnProperty(mode.editValue)

    useEffect(() => {
        const page_Id = pageId.SWEET_POS_RATE_MASTER
        dispatch(commonPageFieldSuccess(null));
        dispatch(commonPageField(page_Id))
        dispatch(getPartyTypelist());
        dispatch(BreadcrumbShowCountlabel(`Count:${0}`));
        return () => {
            dispatch(getPosRateListSuccess([]));
            dispatch(postSelect_Field_for_dropdown_Success([]));
        }
    }, []);

    useEffect(() => { // Rate Type Dropdown useEffect
        const jsonBody = JSON.stringify({
            Company: loginCompanyID(),
            TypeID: 173
        });
        dispatch(postSelect_Field_for_dropdown(jsonBody));
    }, []);

    // const PartyTypeDropdown_Options = PartyTypes.map((Data) => ({
    //     value: Data.id,
    //     label: Data.Name
    // }));

    const PartyTypeDropdown_Options = PartyTypes?.filter((Data) => Data.IsFranchises === true).map((Data) => ({
        value: Data.id,
        label: Data.Name
    }));


    const RateTypeListOptions = RateTypeList
        .filter((item) => item.Name !== "Regular")
        .map((item) => ({
            value: item.id,
            label: item.Name,
        }));

    useEffect(() => {
        if (PosRateMasterListData.length > 0) {
            const original = {};
            const originalDefaults = {};

            PosRateMasterListData.forEach(item => {
                original[item.ItemID] =
                    item.Rate === null || item.Rate === ""
                        ? item.PrimaryRate
                        : item.Rate;
                originalDefaults[item.ItemID] = !!item.IsChangeRateToDefault;
            });

            originalRatesRef.current = original;
            originalDefaultsRef.current = originalDefaults;
        }
    }, [PosRateMasterListData]);

    // userAccess useEffect
    useEffect(() => {
        let userAcc = null;
        let locationPath = location.pathname;

        if (hasShowModal) {
            locationPath = props.masterPath;
        };

        userAcc = userAccess.find((inx) => {
            return (`/${inx.ActualPagePath}` === locationPath)
        })

        if (userAcc) {
            setUserAccState(userAcc)
            breadcrumbReturnFunc({ dispatch, userAcc });
        };
    }, [userAccess])

    //This UseEffect 'SetEdit' data and 'autoFocus' while this Component load First Time.
    useEffect(async () => {
        if ((postMsg.Status === true) && (postMsg.StatusCode === 200)) {
            dispatch(PosRateSave_Success({ Status: false }));
            dispatch(getPosRateListSuccess([]));
            // goButtonHandler();

            if (pageMode === "other") {
                customAlert({
                    Type: 1,
                    Message: postMsg.Message,
                })
            }
            else {
                customAlert({
                    Type: 1,
                    Status: true,
                    Message: postMsg.Message,
                    RedirectPath: url.SWEET_POS_RATE_MASTER
                })

            }
        }
        else if (postMsg.Status === true) {
            dispatch(PosRateSave_Success({ Status: false }))
            dispatch(getPosRateListSuccess([]));
            customAlert({
                Type: 4,
                Message: JSON.stringify(postMsg.Message),
            })
        }
    }, [postMsg])

    const goButtonHandler = () => {
        try {

            if ((rateTypeSelect.length === 0)) {
                customAlert({ Type: 3, Message: alertMessages.rateTypeIsRequired });
                return;
            };
            if ((partyType_dropdown_Select === "")) {
                customAlert({ Type: 3, Message: "Please Select PartyType" });
                return;
            };
            const jsonBody = JSON.stringify({
                "EffectiveFrom": effectiveFrom,
                "POSRateType": rateTypeSelect.value,
                "PartyType": partyType_dropdown_Select.value,
            });

            changedRatesRef.current = {};
            originalRatesRef.current = {};
            originalDefaultsRef.current = {};
            dispatch(getPosRateList_Action({ jsonBody }));
        } catch (error) { }
    };

    function PartyType_Dropdown_OnChange_Handller(e) {
        setPartyType_dropdown_Select(e)

    }

    const trackRowChange = (row) => {
        const currentRate =
            row.Rate === null || row.Rate === undefined || row.Rate === ""
                ? row.PrimaryRate
                : row.Rate;

        const rateChanged =
            String(currentRate) !== String(originalRatesRef.current[row.ItemID]);

        const defaultChanged =
            !!row.IsChangeRateToDefault !== originalDefaultsRef.current[row.ItemID];

        if (rateChanged || defaultChanged) {
            changedRatesRef.current[row.ItemID] = {
                ItemID: row.ItemID,
                Rate: currentRate,
                IsChangeRateToDefault: row.IsChangeRateToDefault
            };
        } else {
            delete changedRatesRef.current[row.ItemID];
        }
    };

    const pagesListColumns = [
        {
            text: "Group",
            dataField: "GroupName",
            headerStyle: () => { return { width: '300px' } },
        },
        {
            text: "SubGroup",
            dataField: "SubGroupName",
            headerStyle: () => { return { width: '300px' } },
        },
        {
            text: "ItemName",
            dataField: "ItemName",
            headerStyle: () => { return { width: '300px' } },
            // sort: true
        },
        {
            text: "Rate",
            dataField: "Rate",
            headerStyle: () => { return { width: '150px' } },
            formatter: (cellContent, row) => {

                return (<span style={{ justifyContent: 'center' }}>
                    < CInput
                        key={`posRate${row.ItemID}`}
                        id=""
                        type="text"
                        defaultValue={row.Rate}
                        cpattern={decimalRegx}
                        className="col col-sm text-end"
                        onChange={(e) => {
                            row["Rate"] = e.target.value;
                            trackRowChange(row);
                        }}
                    />
                </span>)
            },
        },

        {
            text: "Primary Rate (MRP)",
            dataField: "PrimaryRate",
            headerStyle: () => { return { width: '100px' } },
            formatter: (cellContent, row) => {

                return (<span style={{ justifyContent: 'center' }}>
                    < CInput
                        key={`posRate${row.ItemID}`}
                        id=""
                        type="text"
                        disabled={true}
                        defaultValue={row.PrimaryRate}
                        cpattern={decimalRegx}
                        className="col col-sm text-end"
                        onChange={(e) => { row["PrimaryRate"] = e.target.value }}
                    />
                </span>)
            },
        },
        {
            text: "Default Rate",
            dataField: "IsChangeRateToDefault",
            headerStyle: () => { return { width: '200px' } },
            formatter: (cellContent, row) => {

                return (<span style={{ justifyContent: 'center' }}>
                    < Input
                        key={`posRate${row.ItemID}`}
                        id=""
                        type="checkbox"
                        defaultChecked={row.IsChangeRateToDefault}
                        className="col col-sm text-end"
                        onChange={(e) => {
                            row["IsChangeRateToDefault"] = e.target.checked;
                            trackRowChange(row);
                        }}
                    />
                </span>)
            },
        },
    ];

    const SaveHandler = async (event) => {

        event.preventDefault();
        try {

            if (rateTypeSelect.length === 0) {
                customAlert({ Type: 3, Message: alertMessages.rateTypeIsRequired });
                return;
            }
            const changedData = Object.values(changedRatesRef.current);

            if (changedData.length === 0) {
                customAlert({
                    Type: 3,
                    Message: "Please change at least one rate before saving."
                });
                return;
            }

            const jsonBody = JSON.stringify(
                changedData.map((i) => ({
                    POSRateType: rateTypeSelect.value,
                    IsChangeRateToDefault: i.IsChangeRateToDefault,
                    EffectiveFrom: effectiveFrom,
                    Rate: i.Rate,
                    ItemID: i.ItemID,
                }))
            );

            dispatch(PosRateSave_Action({ jsonBody }));

        } catch (e) { }
    };

    if (!(userPageAccessState === '')) {
        return (
            <React.Fragment>
                <PageLoadingSpinner isLoading={(listBtnLoading)} />
                <MetaTags>{metaTagLabel(userPageAccessState)}</MetaTags>
                <div className="page-content" >
                    <div className="px-2   c_card_header text-black " >
                        <div className="row">

                            <Col sm={3}>
                                <FormGroup className=" row mt-2  " >
                                    <Label className="col-sm-3 p-2"
                                        style={{ width: "130px" }}> Effective From</Label>
                                    <Col sm="6">
                                        <C_DatePicker
                                            id="EffectiveDate"
                                            name="EffectiveDate"
                                            placeholder={"DD/MM/YYYY"}
                                            value={effectiveFrom}
                                            onChange={(e, date) => {
                                                setEffectiveFrom(date);
                                                dispatch(getPosRateListSuccess([]));
                                            }}
                                            options={{
                                                altInput: true,
                                                altFormat: "d-m-Y",
                                                dateFormat: "Y-m-d",
                                            }}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col sm={3}>
                                <FormGroup className=" row mt-2  " >
                                    <Label className="col-sm-5 p-2"
                                        style={{ width: "83px" }}> Rate Type</Label>
                                    <Col sm="6">
                                        <C_Select
                                            name="rateType"
                                            value={rateTypeSelect}
                                            isSearchable={true}
                                            className="react-dropdown"
                                            classNamePrefix="dropdown"
                                            autoFocus={true}
                                            options={RateTypeListOptions}
                                            onChange={(e) => {
                                                setRateTypeSelect(e);
                                                dispatch(getPosRateListSuccess([]));
                                            }}
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 2 })
                                            }}
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col sm={3}>
                                <FormGroup className="row  mt-2">
                                    <Label className="col-sm-3 p-2 ml-n4 ">Party Type</Label>
                                    <Col md="9" style={{}}>
                                        <Select
                                            value={partyType_dropdown_Select}
                                            options={PartyTypeDropdown_Options}
                                            className="rounded-bottom"
                                            placeholder="select"
                                            styles={{
                                                menu: provided => ({ ...provided, zIndex: 2 })
                                            }}
                                            autoFocus={true}
                                            onChange={(e) => { PartyType_Dropdown_OnChange_Handller(e) }}
                                            classNamePrefix="select2-selection"
                                        />
                                    </Col>
                                </FormGroup>
                            </Col>
                            <Col sm={3} className=" d-flex justify-content-end" >
                                <Col className="mt-2 col-xxl-2">
                                    <Go_Button
                                        loading={listBtnLoading}
                                        onClick={goButtonHandler} />
                                </Col>
                            </Col>

                        </div>
                    </div>

                    <form noValidate>
                        {/* <ToolkitProvider
                            keyField="ItemID"
                            data={PosRateMasterListData}
                            columns={pagesListColumns}
                            search
                        >
                            {toolkitProps => (
                                <React.Fragment>
                                    <div className="table">
                                        <BootstrapTable
                                            keyField={"ItemID"}
                                            bordered={true}
                                            striped={true}
                                            // defaultSorted={[{
                                            //     dataField: 'ItemName',
                                            //     order: 'asc'
                                            // }]}
                                            noDataIndication={<div className="text-danger text-center ">Record Not available</div>}
                                            classes={"table align-middle table-nowrap table-hover"}
                                            headerWrapperClasses={"thead-light"}
                                            {...toolkitProps.baseProps}
                                            onDataSizeChange={({ dataSize }) => {
                                                dispatch(BreadcrumbShowCountlabel(`Count:${dataSize}`));
                                            }}
                                        />
                                        {globalTableSearchProps(toolkitProps.searchProps)}
                                    </div>

                                </React.Fragment>
                            )
                            }
                        </ToolkitProvider> */}

                        <GlobalCustomTable
                            keyField="ItemID"
                            data={PosRateMasterListData}
                            columns={pagesListColumns}
                            search


                            bordered={true}
                            striped={true}
                            // defaultSorted={[{
                            //     dataField: 'ItemName',
                            //     order: 'asc'
                            // }]}
                            noDataIndication={<div className="text-danger text-center ">Record Not available</div>}
                            classes={"table align-middle table-nowrap table-hover"}
                            headerWrapperClasses={"thead-light"}

                            onDataSizeChange={({ dataCount }) => {
                                dispatch(BreadcrumbShowCountlabel(`Count: ${dataCount}`));
                            }}

                        />

                        {PosRateMasterListData.length > 0 &&
                            <SaveButtonDraggable>
                                <SaveButton pageMode={pageMode}
                                    loading={saveBtnloading}
                                    onClick={SaveHandler}
                                    userAcc={userPageAccessState}
                                />
                            </SaveButtonDraggable>
                        }

                    </form>
                </div>
            </React.Fragment>
        );
    }
    else {
        return (
            <React.Fragment></React.Fragment>
        )
    }
};

export default SweetPOSRateMaster
